import useDataFetcher from '~/components/useDataFetcher';
import type { FnolInboxStatusResponse } from '~/server_shared/openapi/data-contracts';

// The high-demand banner has to appear and clear while a user sits on the FNOL page, not only on
// inbox load. Each poll reaches the AI service, so keep the interval well above the request cost.
const INBOX_STATUS_REFETCH_INTERVAL_MS = 180_000;

export interface IFnolAiInboxStatus {
  inboxStatus: FnolInboxStatusResponse | undefined;
  reloadInboxStatus: () => Promise<FnolInboxStatusResponse | undefined>;
  isInboxStatusLoading: boolean;
  isInboxStatusError: boolean;
}

interface FnolAiInboxStatusProps {
  shouldFetch: boolean;
}

export const useFnolAiInboxStatus = ({ shouldFetch }: FnolAiInboxStatusProps): IFnolAiInboxStatus => {
  const {
    data: inboxStatus,
    reloadData: reloadInboxStatus,
    isLoading: isInboxStatusLoading,
    isError: isInboxStatusError,
  } = useDataFetcher<FnolInboxStatusResponse>(
    '/api/v1/fnol_inbox/inbox/status',
    {},
    {
      shouldFetch,
      refetchInterval: INBOX_STATUS_REFETCH_INTERVAL_MS,
    }
  );

  return {
    inboxStatus,
    reloadInboxStatus,
    isInboxStatusLoading,
    isInboxStatusError,
  };
};
